import '@assets/css/skeleton.css';

export const BranchDetailSkeleton = () => {
  return (
    <div className="mt-4">
      {/* Header skeleton */}
      <div className="card border-0 shadow-sm overflow-hidden">
        <div className="position-relative" style={{ height: 240 }}>
          <div className="shimmer" style={{ height: '100%', width: '100%' }} />
        </div>
        <div className="card-body">
          <div className="d-flex gap-3 mb-3">
            <div className="shimmer rounded-circle" style={{ width: 80, height: 80 }} />
            <div className="flex-grow-1">
              <div className="shimmer" style={{ height: 28, width: '40%', marginBottom: 8 }} />
              <div className="shimmer" style={{ height: 20, width: '60%', marginBottom: 8 }} />
              <div className="shimmer" style={{ height: 24, width: 100, borderRadius: 20 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Body skeleton */}
      <div className="row mt-4 g-3">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="shimmer" style={{ height: 24, width: '40%', marginBottom: 16 }} />
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="d-flex align-items-center gap-2 py-1">
                  <div className="shimmer" style={{ width: 20, height: 20, borderRadius: '50%' }} />
                  <div className="shimmer" style={{ height: 18, width: '60%' }} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="shimmer" style={{ height: 24, width: '40%', marginBottom: 16 }} />
              {['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'].map((day, idx) => (
                <div key={idx} className="d-flex justify-content-between py-1">
                  <div className="shimmer" style={{ height: 18, width: '30%' }} />
                  <div className="shimmer" style={{ height: 18, width: '40%' }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};